// in effort to reduce having duplicative messages throughout the app, this function will return segments of
// verbiage that will be replaced in the termination request templated paragraphs
export const getVerbiageForTerminationRequest = (
  numberOfAccountsSelected: number,
): {
  companyText: string;
  companyPronoun: string;
  companyPronoun2: string;
  accountText: string;
  possessiveCompanyText: string;
  verb: string;
} => {
  if (numberOfAccountsSelected === 1) {
    return {
      companyText: 'company',
      companyPronoun: 'this',
      companyPronoun2: 'it',
      accountText: 'account',
      possessiveCompanyText: `company’s`,
      verb: 'has',
    };
  }
  return {
    companyText: 'companies',
    companyPronoun: 'these',
    companyPronoun2: 'they',
    accountText: 'accounts',
    possessiveCompanyText: `companies’`,
    verb: 'have',
  };
};

export default { getVerbiageForTerminationRequest };
